module.exports = "/assets/a201ffd8e314067f045a88e676823cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BB.png
// module id = 2353
// module chunks = 0